import { render, staticRenderFns } from "./Staffbox.vue?vue&type=template&id=66513f90&scoped=true&"
import script from "./Staffbox.vue?vue&type=script&lang=js&"
export * from "./Staffbox.vue?vue&type=script&lang=js&"
import style0 from "./Staffbox.vue?vue&type=style&index=0&id=66513f90&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66513f90",
  null
  
)

export default component.exports